import styled, { css } from 'styled-components';
export var TableWrapper = styled.div.withConfig({
  displayName: "styled__TableWrapper",
  componentId: "sc-c5vzlr-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["width:100%;overflow-x:auto;border:1px solid ", ";border-radius:", ";background-color:", ";"], theme.colors.grey.light, theme.radii[8], theme.colors.base.white);
});